<div class="bl-margin-bottom--40">
  <ea-accordion-group #crossSellGroup [(accordionGroupMeta)]="accordionGroupMeta">
    <div
    class="bl-block-module bl-display--flex bl-font-color--base bl-padding--16 bl-padding-sm--24 bl-margin-bottom--16"
    id="disclosure-cross-sell"
    >
        <ea-accordion
          #crossSellRef
          controllerPosition="above"
          [controllerInnerHtml]="disclosureTitleHtml()"
          [defaultExpanded]="true"
          controllerClass="bl-display--flex bl-width--100 bl-font-color--base"
          [controllerAriaLabel]="'Accordion ' +  disclosure.title"
          class="bl-width--100"
        >
          <div class="bl-overflow-x--auto">
            <div class="bl-margin-y--16" *ngIf="disclosure.content" [innerHTML]="this.utilitiesService?.normalizeSpaces(disclosure.content | safe : 'html')"></div>
          </div>

          <div class="bl-flex--auto">
            <ng-container *ngIf="disclosure?.applicants">
              <div *ngFor="let applicant of disclosure.applicants; let index = index">
                <div
                  class="bl-display--flex bl-margin-bottom--16 bl-width--100 bl-flex-flow--wrap"
                  [ngClass]="disclosure.applicants.length - 1 != index ? 'bl-padding-right--32' : ''"
                >
                  <ng-container *ngIf="isOAOFlow">
                    <div
                      class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16"
                      aria-label="error"
                      aria-live="assertive"
                      *ngIf="!applicant.readOnly && !applicant.disabled && isNullOrEmpty(applicant.accepted) && (pageSubmitted$ | async)"
                    >
                      {{ getApplicantLabel(applicant.applicant) }} {{ 'crossSellReview/initialMsg' | dictionary }} {{ disclosure.title
                      }}{{ 'crossSellReview/errorMessage' | dictionary }}
                    </div>
                  </ng-container>
                  <div class="bl-check-wrap bl-form-flex-wrap" [ngClass]="{ 'bl-disabled': applicant.disabled || applicant.readOnly }">
                    <label
                      class="bl-label bl-font-color--black bl-font-weight--900 bl-font-size--14 bl-display--inline-block bl-required"
                      [innerHTML]="applicant.label ? getApplicantLabel(applicant.label) : ('crossSellReview/acceptLabel' | dictionary)"
                    >
                    </label>
                    <div class="bl-display--inline-block">
                      <input
                        id="cross-sell-opt-in-{{ index }}"
                        [value]="true"
                        [(ngModel)]="applicant.accepted"
                        type="radio"
                        (change)="updateCrossSellAcceptance(index, crossSellRef)"
                        name="cross-sell-{{ index }}"
                        required
                      />

                      <label
                        class="bl-label bl-font-color--black bl-font-size--14 bl-padding-right--32"
                        for="cross-sell-opt-in-{{ index }}"
                      >
                        {{ 'crossSellReview/optIn' | dictionary }}
                      </label>

                      <input
                        id="cross-sell-opt-out-{{ index }}"
                        [value]="false"
                        [(ngModel)]="applicant.accepted"
                        type="radio"
                        (change)="updateCrossSellAcceptance(index, crossSellRef)"
                        name="cross-sell-{{ index }}"
                        required
                      />

                      <label
                        class="bl-label bl-font-color--black bl-font-size--14"
                        for="cross-sell-opt-out-{{ index }}"
                      >
                        {{ 'crossSellReview/optOut' | dictionary }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ea-accordion>

    </div>
  </ea-accordion-group>
</div>
